<script>
  export let trend = 'up';
  export let size = 'sm';
  export let decorative = true;

  const allowedTrends = ['na', 'up', 'down', 'flat'];
  const allowedSizes = ['sm', 'cell', 'base', 'lg', '2xl'];

  $: resolvedTrend = allowedTrends.includes(trend) ? trend : 'flat';
  $: resolvedSize = allowedSizes.includes(size) ? size : 'sm';
</script>

<div
  class="trend-indicator"
  data-trend={resolvedTrend}
  data-size={resolvedSize}
  aria-hidden={decorative}
  role={decorative ? undefined : 'img'}
></div>
